import { Slide, ToastOptions } from "react-toastify";

export const MENU_CACHE_REVALIDATE_TIME = 60 * 3;

// ===== Product =====
// Marketing text cap, kept in sync with marketingTextMaxChars in
// 7qr_web_api_go/internal/services/product_ai_service.go, which trims
// AI-generated copy to the same length.
export const MARKETING_TEXT_MAX_LENGTH = 150;

// ===== Links =====
export const FACEBOOK_LINK = "https://www.facebook.com/";
export const INSTAGRAM_LINK = "https://www.instagram.com/";
export const TWITTER_LINK = "https://x.com/";

// ===== Cloudflare =====
export const R2Host =
  process.env.NEXT_PUBLIC_CLOUDFLARE_R2_HOST_URL ||
  "https://assets.plusmenu.co";
export const R2BucketName =
  process.env.NEXT_PUBLIC_R2_BUCKET_NAME || "7qrmenucom";

// ===== React-Toastify =====
export const ToastTheme: ToastOptions = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  transition: Slide,
};

// ===== Route Defaults =====
export function getLandingRoute(lang: string, fallback?: string) {
  const route = landingRouteMap[lang];
  return route || fallback || "#";
}

const landingRouteMap: Record<string, string> = {
  tr: "hos-geldiniz",
  en: "welcome",
  ar: "ahlan-wa-sahlan",
  ru: "dobro-pozhalovat",
  de: "willkommen",
  fr: "bienvenue",
  es: "bienvenido",
  zh: "huan-ying",
};
